import React from "react";

const Loading = ( props ) => {

    return ( <span className={`block w-12 h-12 rounded-full border-2 border-green-800 border-t-transparent animate-spin mx-auto ${props.className}`}></span> )
}
export default Loading;